export default class Internationalization {


    messages:any={
        "Zoom Avant":{
            "fr":"Zoom Avant",
            "en":"Zoom In"
        },
        "Zoom Arrière":{
            "fr":"Zoom Arrière",
            "en":"Zoom out"
        },
        "Couches de données":{
            "fr":"Couches de données",
            "en":"Layer list"
        },
        "Revenir à la Vue Globale":{
            "fr":"Revenir à la Vue Globale",
            "en":"Go back to Initial view"
        }


    }

    getText(lang: string, key: string) {
        let m=this.messages[key];
        if(m){
            let trad=m[lang];
            if(trad){
                return trad;
            }
            else{
                return key;
            }
        }
        else{
            return key;
        }

    }
}
